<p-toast></p-toast>
<canvas #myCanvas height="0" width="0"></canvas>
<div *ngIf="userService.hasAnyRole(['admin', 'editor'])">
    <input type="file" id="file" accept="image/*" (change)="handleFileInput($event)">
    <button *ngIf="!pictureLoaded" (click)="uploadFile()">Upload new picture</button>
    <button *ngIf="pictureLoaded" (click)="updateFile()">Update picture</button>
</div>